module.exports = __webpack_public_path__ + "static/media/m_beard_scruff_long__square.92cf0ef6.png";